import { CustomHttpError, httpClient } from '../helpers/httpClient';

export async function addFirebaseDevice(token: string): Promise<void> {
  try {
    await httpClient.post('/firebase/device', {
      token,
    });

    return Promise.resolve();
  } catch (e) {
    if (e instanceof CustomHttpError || e instanceof Error) {
      return Promise.reject(e.message);
    }

    console.error(e);
    return Promise.reject('unknown error');
  }
}
